import { Locale } from '@headless-workspace/config';
import { Repository, Result, ResultFailureFromApiError, ResultSuccess } from '@headless-workspace/core-domain';
import {
    memoryCacheAuthStrategy,
    memoryCacheQueryParamStrategy,
    memoryCacheRefreshTokenStrategy,
} from '@headless-workspace/data';
import { ReviewTranslationDTO } from './ReviewTranslationDTO';
import { ReviewTranslationPayload } from './ReviewTranslationPayload';
import { mapReviewTranslation, ReviewTranslationValue } from './ReviewTranslationValue';

export interface ReviewTranslationRepositorySpec {
    translateReview(locale: Locale, payload: ReviewTranslationPayload): Promise<Result<ReviewTranslationValue>>;
}

export class ReviewTranslationRepository extends Repository implements ReviewTranslationRepositorySpec {
    path = '/content/v1/translate';

    constructor() {
        super(memoryCacheAuthStrategy, memoryCacheRefreshTokenStrategy, memoryCacheQueryParamStrategy);
    }

    async translateReview(locale: Locale, payload: ReviewTranslationPayload): Promise<Result<ReviewTranslationValue>> {
        try {
            const response = await this.datasource.createResource<ReviewTranslationPayload, ReviewTranslationDTO>(
                this.path,
                payload,
                {
                    locale,
                },
            );

            return ResultSuccess(mapReviewTranslation(ReviewTranslationDTO.parse(response)));
        } catch (error) {
            const apiError = this.handleApiError(error);
            return ResultFailureFromApiError(apiError, { locale });
        }
    }
}
